import React from "react";

const LabelChartKeteranganProgLit = ({
    listData,
    sekolah
}) => {
    let dataProgres = listData
    require("./Ensa.css");
    return (
        <div>
            {dataProgres.map((item, i) =>
                <div style={{ width: '100%', display: 'flex', gap: '20px', marginTop: '20px' }} key={i}>
                    <div className="label-dot" style={{ backgroundColor: item.color }}></div>
                    <div>
                        <p className="label-title">{item.key}</p>
                        <span className="liteDesc">Rata-rata indeks literasi {item.key == 'LITERASI MEMBACA' ? 'membaca' : item.key == 'LITERASI SAINS' ? 'sains' : 'matematika'} siswa di <b>{sekolah}</b> mengalami kenaikan dari tahun sebelumnya</span>
                    </div>
                </div>
            )}
        </div>
    );
};

export default LabelChartKeteranganProgLit;
